import { useEffect } from 'react';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

import Head from 'next/head';
import styles from 'styles/pages/terms-privacy.module.scss';
import CcpaNoticeIndependentContractorsLocale from 'locale/en/ccpa-notice-independent-contractors.json';
import MiscLocale from 'locale/en/misc.json';
import PrivacySideNav from 'components/privacy/side-nav';
import { pageReplaced } from 'lib/utils/page-replaced';
import { getContentSection } from 'lib/contentful/get-content-section';
import { getContentField } from 'lib/contentful/get-content-field';
import { createMarkup } from 'lib/utils/create-markup';
import { getContentfulDataDirect } from 'lib/contentful/get-contentful-data-direct';

const PageData = {
  page_type: 'default',
  page_class: 'page-privacy',
  page_name: CcpaNoticeIndependentContractorsLocale.page_name,
  page_title: CcpaNoticeIndependentContractorsLocale.page_title,
  page_description: CcpaNoticeIndependentContractorsLocale.page_desc,
};
const PageHead = () => (
  <Head>
    <title>{`${MiscLocale.brand} • ${PageData.page_title}`}</title>
    <meta name='description' content={PageData.page_description} />
  </Head>
);

const PagePrivacy = ({ page }) => {
  useEffect(() => {
    pageReplaced(PageData);
  });

  const section = getContentSection({
    data: page,
    include: 'CCPA Notice for Contractors - Main Section',
  })?.shift();

  const content = getContentField({
    data: section,
    title: 'CCPA Notice for Contractors - Main Paragraph',
  });

  return (
    <>
      <PageHead />
      <div className={styles.container}>
        <div className={styles.aside}>
          <PrivacySideNav pageUrl='/ccpa-notice-independent-contractors' />
        </div>
        <div className={styles['sections-list']}>
          <section
            dangerouslySetInnerHTML={createMarkup(
              documentToHtmlString(content).replace(/\n/g, `<br/>`),
            )}
          />
        </div>
      </div>
    </>
  );
};

export async function getStaticProps() {
  const privacyQuery = {
    content_type: 'page',
    'fields.slug': 'ccpa-notice-for-contractors',
    include: 10,
  };

  const contentPayload = await getContentfulDataDirect(privacyQuery);

  const props = {
    page: contentPayload.items[0].fields,
  };

  return {
    props,
    revalidate: 60 * 60, // One hour in seconds
  };
}

export default PagePrivacy;
